import getUrlParameter from "helpers/getUrlParameter";
import Cookies from "js-cookie";
const tags = ["pds", "pdm"];
const retrieve = () => {
    const items = {};
    tags.forEach((key) => {
        const value = getUrlParameter(key) || Cookies.get(`cookie_${key}`);
        if (value) {
            items[key] = getUrlParameter(key) || Cookies.get(`cookie_${key}`) || "";
        }
    });
    return items;
};
export default retrieve;
